import styled from "styled-components";

export default styled.div`
  display: block;
  position: absolute;
  top: 70px;
  bottom: 40px;
  left: 0;
  right: 0;
  padding: 20px 0;

  & > div {
    margin-bottom: 100px;
  }
`;
